import { SIDEBAR_COLLAPSED } from "./types";

export const setSidebarCollapsedActions = () => ({
    type: SIDEBAR_COLLAPSED,
});